export default "__VITE_ASSET__Dj26wWZF__"